/*
 * Copyright (c) 2019 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import enUS from "./translations/en-US.json";
import zhCN from "./translations/zh-CN.json";
import deDE from "./translations/de-DE.json";
import esES from "./translations/es-ES.json";
import frFR from "./translations/fr-FR.json";
import itIT from "./translations/it-IT.json";
import jaJP from "./translations/ja-JP.json";
import koKR from "./translations/ko-KR.json";
import plPL from "./translations/pl-PL.json";
import ptBZ from "./translations/pt-BZ.json";
import ruRU from "./translations/ru-RU.json";
import trTR from "./translations/tr-TR.json";
import zhTW from "./translations/zh-TW.json";

export default {
  "en-US": enUS,
  "zh-CN": zhCN,
  "zh-TW": zhTW,
  "de-DE": deDE,
  "es-ES": esES,
  "fr-FR": frFR,
  "it-IT": itIT,
  "ja-JP": jaJP,
  "ko-KR": koKR,
  "pl-PL": plPL,
  "pt-BZ": ptBZ,
  "ru-RU": ruRU,
  "tr-TR": trTR,
};

export const languageMap = {
  "en-US": "English",
  "zh-CN": "中文 (简体)",
  "zh-TW": "中文 (繁體)",
  "de-DE": "Deutsch",
  "es-ES": "Español",
  "fr-FR": "Français",
  "it-IT": "Italiano",
  "ja-JP": "日本語",
  "ko-KR": "한국인",
  "pl-PL": "Polski",
  "pt-BZ": "Português",
  "ru-RU": "Русский",
  "tr-TR": "Türkçe",
};
